<template>
  <div>
    <div class="d-flex i-mb-14 justify-content-between align-items-center">
      <div>
        <h5 class="i-text-heading-5 i-text-neutral-120 i-mb-2">
          Document Checks
        </h5>
        <p class="i-text-body-2 i-text-neutral-110 subheading-wrap">
          A check is a set of trigger conditions and requirement conditions that
          can be applied to your documents.
          <em>Checks</em> can check that all documents uploaded are of a given
          type, are still in date, are less than 90 days old, and much more.
        </p>
      </div>
      <div class="flex-shrink-0">
        <i-button
          v-if="isOrgAdmin"
          text="New Check"
          data-testid="new-check-button"
          size="md"
          @button-click="addCheck()"
        ></i-button>
      </div>
    </div>
    <div class="align-items-start rules-list">
      <div
        v-if="checks.length > 0"
        class="d-flex flex-column w-100 mt-5 checks-list"
        data-testid="checks"
      >
        <check-editor
          v-for="check in checks"
          :key="`${check.id}_${check.name}`"
          :check="check"
          :can-edit="isOrgAdmin"
        />
      </div>
      <div
        v-if="checks.length === 0 && !checksLoading"
        class="rules-empty-state w-100 mt-3 d-flex flex-column justify-content-center align-items-center p-4"
      >
        <h5 class="i-text-subheading-1 i-text-neutral-110">
          You haven't made added any checks yet
        </h5>
        <i-button
          v-if="isOrgAdmin"
          text="Create a Check"
          type="primary"
          subtype="outline"
          data-testid="create-a-check-button"
          size="sm"
          @button-click="addCheck()"
        ></i-button>
        <span v-else>Only admins can create checks</span>
      </div>
      <div
        v-if="checksLoading"
        class="d-flex my-5 w-100 align-items-center justify-content-center"
      >
        <i-spinner></i-spinner>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { iButton, iSpinner } from '@inscribe/signal';
import RuleEngine from '@/utils/ruleEngine';
import CheckEditor from './CheckEditor';

export default {
  components: {
    iButton,
    iSpinner,
    'check-editor': CheckEditor,
  },
  data() {
    return {
      showNewRuleModal: false,
      newRule: null,
      ruleError: null,
      mode: '',
    };
  },
  computed: {
    ...mapGetters({
      isOrgAdmin: 'isOrgAdmin',
    }),
    checks() {
      return this.$store.state.config.checks.slice().reverse();
    },
    checksLoading() {
      return this.$store.state.config.checksLoading;
    },
    isValidRuleSet() {
      return (
        this.rulesSchema &&
        this.rulesSchema.variables &&
        new RuleEngine(this.rulesSchema).isValidRuleSet(
          this.$store.state.config.rules,
        )
      );
    },
  },
  mounted() {
    if (this.isOrgAdmin) {
      this.getConfigChecks();
    }
  },
  methods: {
    ...mapActions({
      getConfigChecks: 'getConfigChecks',
    }),
    addCheck() {
      this.$store.commit('addCheck', {
        name: `Check #${this.checks.length + 1}`,
        triggers: [],
        requirements: [
          {
            name: null,
            operator: null,
            value: null,
          },
        ],
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.checks-list {
  border-radius: $border-radius-default;
}

.subheading-wrap {
  max-width: 70%;
}
</style>
